





































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import CategoryTree from "@/modules/support/components/Guide/CategoryTree.vue";
import Category from "@/modules/support/model/Category";

interface CategoryNode {
    entity: Category
    id: string
    description: string
    children: CategoryNode[]
}

/**
 * Selector de categorías
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { CategoryTree: () => import('./CategoryTree.vue') }
})
export default class CategorySelector extends Vue {
    /**
     * Lista de categorías seleccionadas
     */

    @Prop({type: Array, default: () => []})
    public value: Category[]
    /**
     * Label para el campo
     */
    @Prop({type: String, default: 'Selecciona categorías'})
    public label: string

    @Prop({type: Boolean, default: false})
    public multiple: boolean

    /**
     * Lista de categorías que no serán mostradas en el arbol
     */
    @Prop({type: Array, default: () => []})
    public exclude: Category[]

    /**
     * Reglas para validar el campo
     */
    @Prop({type: Array, default: () => []})
    public rules: Array<(value: string) => string | true>

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    public selectorDialog = false
    public categoriesLoaded = false
    public loading = false

    public active: CategoryNode[] = []

    /**
     * Lista de categorías seleccionadas
     */
    public selected: Category[] = []

    @Watch('selectorDialog')
    async watchDialog (open: boolean) {
        if (!open || this.categoriesLoaded) return

        this.loading = true
        await this.$store.dispatch('support/loadRootCategory')
        this.categoriesLoaded = true
        this.loading = false
    }

    @Watch('value', {immediate: true})
    watchValue (value: Category[]) {
        this.selected = value
    }

    public get inputValue () {
        return this.selected.map(c => c.name).join(', ')
    }

    /**
     * Guarda los cambios de selección realizados por el usuario
     */
    public select () {
        this.selectorDialog = false
        this.selected = this.active.map(n => n.entity)
        this.$emit('input', this.selected)
    }
}
